import { Button } from "@/shadcnComponents/ui/button";
import { SidebarTrigger } from "@/shadcnComponents/ui/sidebar";
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shadcnComponents/ui/table";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const host: string = import.meta.env.VITE_BACKEND_SERVER_URL;

export const AdminDeals = ({ handleLogout }) => {
  const [allDeals, setAllDeals] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const getAllDeals = async () => {
      const response = await fetch(`${host}/developer/getallDeals`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Access-Control-Allow-Credentials": "true",
          jwtToken: localStorage.getItem("jwtTokenD"),
        },
      });
      const json = await response.json();

      if (json.success) {
        setAllDeals(json.allDeals);
      } else {
        toast.error("You are not allowed to Access", { autoClose: 1500 });
        handleLogout();
        window.open("/developer/login", "_self");
      }
    };
    getAllDeals();
  }, []);

  const getDate = (date) => {
    const d = new Date(date);

    const newDate = d.toDateString().split(" ");

    return (
      // newDate[0] + " | " + newDate[1] + " " + newDate[2] + " " + newDate[3]
      newDate[2] + " " + newDate[1] + " " + newDate[3]
    );
  };

  return (
    <>
      <div className="flex flex-col gap-6  w-full h-full">
        <header className="flex h-16 shrink-0 items-center gap-2 border-b px-6">
          <SidebarTrigger />
          <h1 className="text-2xl font-bold">All Deals</h1>
        </header>
        <div className="flex flex-col px-[20px] w-full h-full items-center justify-center gap-[20px]">
          <div className="w-full flex justify-end ">
            <Button onClick={() => navigate("/developer/admin/deals/add")}>
              Add new deal
            </Button>
          </div>
          <Table style={{ scrollbarWidth: "thin" }}>
            <TableCaption>A list of All Brand Deals.</TableCaption>
            <TableHeader>
              <TableRow>
                <TableHead className="w-[100px]">Company Name</TableHead>
                <TableHead>Website link</TableHead>
                <TableHead>Min. Followers Required</TableHead>
                <TableHead className="text-right">
                  Min Collab Required
                </TableHead>
                <TableHead className="text-right">Created On</TableHead>
                <TableHead className="text-right">Condition to show</TableHead>
                <TableHead className="text-right">Apply Link</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {allDeals?.map((item, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell className="font-medium">
                      {item?.companyName}
                    </TableCell>
                    <TableCell>{item?.websiteLink}</TableCell>
                    <TableCell>{item?.minFollower}</TableCell>
                    <TableCell>{item?.minCollab}</TableCell>
                    <TableCell>{getDate(item?.createdAt)}</TableCell>
                    <TableCell>
                      <div className="flex flex-col">
                        <span>Min {item?.minchips || 0} Chips</span>
                        {item?.profileVisible && (
                          <span>Profile should be visible</span>
                        )}
                      </div>
                    </TableCell>
                    <TableCell>{item?.formLink}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </div>
    </>
  );
};
